import { get } from 'svelte/store';
import { planning } from '../../../stores/store';
import { openModal } from 'svelte-modals';
import ModalStartPlanning from '../Modals/ModalStartPlanning.svelte';
import { ScenarioApi } from './ScenarioApi';
import { api } from '../../../stores/api';
import { _ } from 'svelte-i18n';
import type { Assignment } from './Assignment';
import { AssignmentApi } from './AssignmentApi';
import ModalUnlockAssignment from '../Modals/ModalUnlockAssignment.svelte';

export function unlockAssignmentIfPossible(
    assignment: Assignment,
    fnContinue: Function,
    fnCancel: Function | null = null
) {
    if (!assignment.isLocked() || assignment.isDownloaded()) {
        fnContinue();
    } else {
        openModal(ModalUnlockAssignment, {
            onClick: async () => {
                try {
                    await AssignmentApi.setLocked(get(api), assignment.getId(), false);
                    assignment = assignment.setLocked(false);
                    fnContinue();
                } catch (err) {
                    console.error('unlockAssignmentIfPossible: ' + err);
                    alert(
                        get(_)(
                            'Nie udało się odblokować tej trasy. Spróbuj ponownie lub skontaktuj się z pomocą techniczną.'
                        )
                    );
                    if (typeof fnCancel == 'function') {
                        fnCancel();
                    }
                }
            },
            onCancel: () => {
                if (typeof fnCancel == 'function') {
                    fnCancel();
                }
            },
        });
    }
}
